<template minapp="mpx" xlang="wxml">
 <es-layout
    custom-class="custom-class"
    navbarTitle="联系方式核验"
    layout="{{['header', 'footer']}}"
    navbarStyle="{{navbarStyle}}"
    esMainStyle="{{esMainStyle}}"
    leftArrow="{{true}}"
  >
 <view class="verify-main">
   <image mode="widthFix"
   wx:style="width: 100%; box-sizing: border-box;
    padding: 10px 17px;"
   src="https://img-hxy021.didistatic.com/static/starimg/img/GKpTRbIyQn1683717815389.png"/>
   <view class="verify-card">
    <view><text class="verify-card__status">当前状态 {{mobileStatusTxt}} </text><text class="verify-card__time">{{refreshTime}}秒后自动刷新</text></view>
    <view class="verify-card__refresh" bind:tap="refreshStatus">刷新</view>
   </view>
   <order-title-card title="请按照以下提示完成核验" customStyle="{{customStyle}}">
    <view class="verify-tips verify-tips__title">
      1.发送短信
    </view>
    <view class="verify-tips verify-tips__subtitle">
      请告知乘客{{passengerName}}使用手机号码{{passengerPhone}}发送下方验证码至12306
    </view>

    <view class="verify-tips verify-tips__title">
      2.验证码
    </view>
    <view class="verify-code-card">
      <text class="verify-code-card__code">{{captcha}} </text>
      <view class="es-flex"><text class="verify-code-card__time">倒计时{{consultTimeTxt}}</text> <view class="verify-code-card__copy" bind:click="copy">复制</view></view>
   </view>

   </order-title-card>
    <warm-tips wx:if="{{isShowWarmTips}}" title="温馨提示" content="{{warmTips}}" from="success" />
  </view>
  <view class="footer" slot="footer">
    <es-button custom-class="left-button"  size="large" wx:style="flex:1;margin-right:4px" bind:click='ownCheck'>我来核验</es-button>
    <es-button custom-class="right-button" size="large" wx:style="flex:1;margin-left:4px"  bind:click='otherCheck'>邀请好友核验</es-button>
  </view>

 </es-layout>
 <es-toast id='es-toast' />
</template>


<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { xenv } from '@didi/webx-js'
  import { TrainMobileStatus } from '@/common/enum'
  import Toast from '@didi/es-mpx-ui/lib/toast/functional'
  import { setClipboardData } from '@didi/es-mpx-shared'
  // import { getPassengerValidateStatus, trainPassengerValidate } from '@/api/passenger'
  // TODO 替换接口 - 联调时没有问题可把上边一行删除
  import { getPassengerValidateStatus } from '@/api/passenger'
  import { USER_VALIDATE_TOC } from '@/api/urls'
  import { AES_ECB_DECRYPT } from '../../common/crypto'
  createPage({
    data() {
      return {
        curUserName: '',
        passengerName: '',
        passengerPhone: '',
        captcha: '',
        captchaTime: '',
        consultTime: '',
        refreshTime: '',
        timer: '',
        refreshTimer: '',
        mobileStatus: 0,
        navbarStyle: {
          background: '#1473FF',
          'font-size': '18px',
          'font-weight': 600,
          color: '#ffffff',
          'font-family': 'PingFangSC-Semibold'
        },
        esMainStyle: {
          background: '#F0F1F4'
        },
        customStyle: {
          paddingTop: '6px',
          margin: '10px 0 0'
        },
        warmTips: [
          '1、请根据以上提示完成核验操作',
          '2、如验证码失效，可点击刷新获取最新验证码',
          '3、如点击底部按钮无反应，您也可以直接使用手机短信功能发送验证码'
        ],
      }
    },

    computed: {
      ...store.mapState({
        contactVerifyParams: 'newContacts.contactVerifyParams'
      }),
      isShowWarmTips() {
        return xenv() === 'alimp'
      },
      consultTimeTxt() {
        if (this.consultTime) {
          const min = parseInt(this.consultTime / 60)
          const second = this.consultTime - min * 60
          return `${min}分${second}秒`
        } else if (this.consultTime === 0) {
          return '0分0秒'
        } else {
          return ''
        }
      },
      mobileStatusTxt() {
        let map = new Map([
          [TrainMobileStatus.UNVERIFY, '待核验'],
          [TrainMobileStatus.PASSED, '核验成功'],
          [TrainMobileStatus.FAIL, '核验失败']
        ])
        return map.get(+this.mobileStatus)
      }
    },

    methods: {
      ...store.mapMutations({}),
      //核验倒计时
      updateEndTime(endTime) {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        if (endTime <= 0) {
          //倒计时为0 之后 自动拉去刷新接口
          this.fetchPassengerValidateData()
          // 关闭立即支付按钮可点击态
          this.consultTime = 0
          return
        }
        this.consultTime = endTime
        this.timer = setTimeout(() => this.updateEndTime(--endTime), 1000)
      },
      //刷新倒计时
      updateRefreshTime(endTime) {
        if (this.refreshTimer) {
          clearTimeout(this.refreshTimer)
        }
        if (endTime <= 0) {
          //倒计时为0 之后 自动拉去刷新接口
          this.fetchPassengerValidateData()
          // 关闭立即支付按钮可点击态
          this.refreshTime = 0
          return
        }
        this.refreshTime = endTime
        this.refreshTimer = setTimeout(() => this.updateRefreshTime(--endTime), 1000)
      },
      copy() {
        if (__mpx_mode__ == 'dd') {
          setClipboardData(this.captcha)
        } else {
          this.copyText(this.captcha)
        }
      },
      /* 复制内容到粘贴板
       * content : 需要复制的内容
       */
      copyText(text) {
        // 数字没有 .length 不能执行selectText 需要转化成字符串
        const textString = text.toString()
        let input = document.querySelector('#copy-input')
        if (!input) {
          input = document.createElement('input')
          input.id = 'copy-input'
          input.readOnly = 'readOnly' // 防止ios聚焦触发键盘事件
          input.style.position = 'absolute'
          input.style.left = '-1000px'
          input.style.zIndex = '-1000'
          document.body.appendChild(input)
        }

        input.value = textString
        // ios必须先选中文字且不支持 input.select();
        selectText(input, 0, textString.length)
        if (document.execCommand('copy')) {
          document.execCommand('copy')
          mpx.showToast({
            title: '复制成功',
            icon: 'none'
          })
        } else {
          mpx.showToast({
            title: '复制失败',
            icon: 'none'
          })
        }
        input.blur()

        // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
        // 选择文本。createTextRange(setSelectionRange)是input方法
        function selectText(textbox, startIndex, stopIndex) {
          if (textbox.createTextRange) {
            //ie
            const range = textbox.createTextRange()
            range.collapse(true)
            range.moveStart('character', startIndex) //起始光标
            range.moveEnd('character', stopIndex - startIndex) //结束光标
            range.select() //不兼容苹果
          } else {
            //firefox/chrome
            textbox.setSelectionRange(startIndex, stopIndex)
            textbox.focus()
          }
        }
      },
      // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
      // 选择文本。createTextRange(setSelectionRange)是input方法
      selectText(textbox, startIndex, stopIndex) {
        if (textbox.createTextRange) {
          //ie
          const range = textbox.createTextRange()
          range.collapse(true)
          range.moveStart('character', startIndex) //起始光标
          range.moveEnd('character', stopIndex - startIndex) //结束光标
          range.select() //不兼容苹果
        } else {
          //firefox/chrome
          textbox.setSelectionRange(startIndex, stopIndex)
          textbox.focus()
        }
      }
    },
    fetchPassengerValidateData() {
      mpx.$http
        .post(USER_VALIDATE_TOC, { data: { user: this.contactVerifyParams } })
        .then(({ code, message, success, data }) => {
          if (success) {
            if (code === '0') {
              if (code) {
                const {
                  passenger_name,
                  id_no,
                  passenger_phone,
                  captcha,
                  captcha_time,
                  mobile_status
                } = data
                this.passengerName = passenger_name
                this.passengerPhone = AES_ECB_DECRYPT(passenger_phone)
                this.captcha = captcha
                this.mobileStatus = mobile_status
                this.captchaTime = captcha_time
                this.idNo = id_no
                let countTime = Math.ceil(this.captchaTime - new Date().getTime() / 1000)
                this.updateEndTime(countTime)
                this.updateRefreshTime(60)
              } else {
                Toast({
                  message: message || LOAD_FAIL_CONTENT,
                  overlay: false
                })
              }
            }
          } else {
            Toast({
              message: LOAD_FAIL_CONTENT,
              overlay: false
            })
          }
        })
        .catch((e) => {
          console.log('e=====>', e)
        })
        .finally(() => {
          mpx.hideLoading()
        })
    },
    refreshStatus() {
      //小程序上 定时器无法销毁
      const pages = getCurrentPages() || []
      var currentPage = pages[pages?.length - 1]
      if (pages.length - 1 > 0) {
        var currentPage = pages[pages?.length - 1]
        if (currentPage?.route != 'pages/passenger/passenger-contact-verify-page') {
          return
        }
      }
      this.fetchPassengerValidateData()
      // let params = {
      //   id_no: this.idNo,
      //   passenger_name: this.passengerName
      // }
      // getPassengerValidateStatus(params)
      //   .then(({ code, message, success, data }) => {
      //     if (success) {
      //       if (code === '0') {
      //         const { list } = data || {}
      //         this.mobileStatus = data?.list?.[0].mobile_status
      //       } else {
      //         Toast({
      //           message: message || LOAD_FAIL_CONTENT,
      //           overlay: false
      //         })
      //       }
      //     } else {
      //       Toast({
      //         message: LOAD_FAIL_CONTENT,
      //         overlay: false
      //       })
      //     }
      //   })
      //   .catch((e) => {
      //     console.log('e=====>', e)
      //   })
      //   .finally(() => {
      //     mpx.hideLoading()
      //     this.updateRefreshTime(60)
      //   })
    },
    ownCheck() {
      if (__mpx_mode__ == 'web') {
        let url = `sms:12306?body=${this.captcha}`
        window.location.href = this.getMsgUrl(url)
        return
      }

      dd.shareMessage({
        recipients: ['12306'],
        content: this.captcha
      })
    },
    getMsgUrl(url) {
      const platform = mpx.getSystemInfoSync().platform
      if (platform == 'iPhone' || platform == 'ios') {
        return url.replace('?', '&')
      } else {
        return url
      }
    },
    otherCheck() {
      if (__mpx_mode__ == 'web') {
        let url = `sms:${this.passengerPhone}?body=${this.curUserName}正在为您代订火车票，需要您在 30 分钟内，发送验证码${this.captcha}至 12306完成联系方式验证，才可继续预订。`
        window.location.href = this.getMsgUrl(url)
        return
      }
      dd.shareMessage({
        recipients: [this.passengerPhone],
        content: `${this.curUserName}正在为您代订火车票，需要您在 30 分钟内，发送验证码${this.captcha}至 12306完成联系方式验证，才可继续预订。`
      })
    },
    mounted() {
      const { from, id_no, cur_username = '' } = this.$mpxRoute.query || {}
      this.curUserName = cur_username
      this.idNo = decodeURIComponent(id_no)
      //细分场景
      this.fetchPassengerValidateData()
    },
    onHide() {
      if (this.refreshTimer) {
        //清除定时器 同时释放内存
        clearTimeout(this.refreshTimer)
        this.refreshTimer = null
      }
    },
    destroyed() {
      if (this.timer) {
        //清除定时器 同时释放内存
        clearTimeout(this.timer)
        this.timer = null
      }
      if (this.refreshTimer) {
        //清除定时器 同时释放内存
        clearTimeout(this.refreshTimer)
        this.refreshTimer = null
      }
    }
  })
</script>
<style scoped lang="stylus">
  .verify-main
    padding 0 12px
    background-repeat no-repeat
    background-size 100vw
    background-image url('https://img-hxy021.didistatic.com/static/starimg/img/GhAT99OZEA1683711738840.png')
    background linear-gradient(to bottom, #1473FF, #F0F1F4)
  .verify-card
    font-size 12px
    margin-top -10px
    background rgba(255, 255, 255, 0.8)
    display flex
    padding 16px
    justify-content space-between
    border-radius 8px
    &__status
      font-family PingFangSC-Semibold
      color #333333
      font-weight 600
    &__time
      color #999999
      margin-left 14px
    &__refresh
      color #1473FF
  .verify-code-card
    background #F6F7F8
    padding 12px 16px
    border-radius 8px
    font-size 12px
    display flex
    justify-content space-between
    &__code
      color #333333
      height 24px
      line-height 26px
    &__time
      color #FF7D41
      height 24px
      line-height 26px
    &__copy
      height 24px
      width 60px
      background #fff
      border 1px solid #e5e5e5
      border-radius 4px
      color #1473ff
      line-height 24px
      text-align center
      margin-left 9px
  .verify-tips
    font-size 12px
    color #333333
    &__title
      font-weight bold
      margin-bottom 4px
    &__subtitle
      font-weight 400
      margin-bottom 20px
  .footer
    background white
    height 88px
    padding 0px 12px
    position fixed
    left 0
    right 0
    bottom 0
    display flex
    justify-content space-around
    align-items center
    box-shadow 0 -4px 10px RGBA(0, 0, 0, 0.04)
    font-size 12px
  .left-button
    font-size 16px
    font-weight 600
    height 48px
    color #1473FF
    box-sizing border-box
    text-align center
    font-family PingFangSC
    border 1px solid #1473FF
    border-radius 8px
    background-color #ffffff
    text-align center
  .right-button
    font-size 16px
    font-weight 600
    height 48px
    text-align center
    color white
    border-width 0px
    border-radius 8px
    background-color #1473FF
</style>

<script name="json">
  module.exports = {
    usingComponents: {
      'warm-tips': '@/components/warm-tips',
      'es-toast': '@didi/es-mpx-ui/lib/toast',
      'order-title-card': '@/components/order-title-card'
    }
  }
</script>